// src/stores/ui.ts
import { defineStore } from 'pinia'

type ToastType = 'success' | 'error' | 'info' | 'warning'

interface ToastState {
  message: string
  type: ToastType
  visible: boolean
}

export const useUiStore = defineStore('ui', {
  state: (): { toast: ToastState } => ({
    toast: {
      message: '',
      type: 'info',
      visible: false,
    },
  }),
  actions: {
    showToast(message: string, type: ToastType = 'info', duration = 3000) {
      this.toast.message = message
      this.toast.type = type
      this.toast.visible = true

      if (duration > 0) {
        setTimeout(() => {
          this.toast.visible = false
        }, duration)
      }
    },
    hideToast() {
      this.toast.visible = false
    },
  },
})
